import React from "react";
import { Navigate } from "react-router-dom";
import { hasAnyPermission } from "../permissions";
const clearLoginSession = () => {
  localStorage.removeItem("isAuthenticated");
  localStorage.removeItem("loggedInUser");
  localStorage.removeItem("loggedInRole");
  localStorage.removeItem("role");
};

const PrivateRoute = ({ children, allowedRoles, requiredPermissions }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  const loggedInRole = localStorage.getItem("loggedInRole");

  if (!isAuthenticated || !loggedInRole) {
    clearLoginSession();
    return <Navigate to="/admin" replace />;
  }

  // If allowedRoles is not passed, only login is checked
  if (Array.isArray(allowedRoles) && allowedRoles.length > 0) {
    const roleAllowed = allowedRoles.includes(loggedInRole);

    // A granular permission (assigned via Settings) can additionally grant
    // access even when the role alone wouldn't — this is an OR, never a
    // restriction on top of what the role already allows.
    const permissionAllowed =
      Array.isArray(requiredPermissions) &&
      requiredPermissions.length > 0 &&
      hasAnyPermission(requiredPermissions);

    if (!roleAllowed && !permissionAllowed) {
      clearLoginSession();
      return <Navigate to="/admin" replace />;
    }
  }

  return children;
};

export default PrivateRoute;
